import React from 'react';
import Typography from '../../components/Typography';
import Button from '../../components/Button';
import { withRouter } from 'react-router-dom';

const CannotAccess = ({ history }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: '16px',
      }}
    >
      <Typography variant="subtitleTwo" bold >
        You are not authorized to access this page.
        <br />
        Please contact your administrator to request access.
      </Typography>
      <Button
        label="Go to Home"
        onClick={() => {
          history.push('/');
        }}
      />
    </div>
  );
};

export default withRouter(CannotAccess);
